import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';
import {Tooltip} from 'common/components/tooltip';
import {IconSizeType} from 'common/constants';

import {UserListAttrs} from './types';
import {template} from './template';
import css from './index.inline.styl';
import {track, TrackingEvent} from './tracking';

type JsxProps = {
  attrs?: UserListAttrs;
};

export class UserList extends Component<EmptyObj, UserListAttrs> {
  static get attrsSchema(): AttrsSchema<UserListAttrs> {
    return {
      ...super.attrsSchema,
      users: {
        type: `json`,
        tsType: `UserItem[]`,
      },
      clickable: {type: `boolean`, description: `Have the component emit click events and apply basic hover styles`},
      'disable-tooltip': `boolean`,
      'editor-user': {
        type: `json`,
        tsType: `EditorUser`,
        description: `Provided in the context of viewing an entity, shows last editor of said entity.`,
      },
      'tooltip-placement': Tooltip.attrsSchema[`placement`],
      'more-text': {
        type: `string`,
        description: `Text to display after count when the number of items is greater than 'show-max'`,
        default: `more`,
      },
      'user-count-override': {
        type: `number`,
        description: `Overrides the count after more - text`,
        default: null,
      },
      'max-icons-displayed': {
        type: `number`,
        default: 7,
        description: `Maximum number of icons to show before replacing with the truncated text`,
      },
      'max-icons-total': {
        type: `number`,
        default: 20,
        description: `Maximum total number of users shown (inline max-icons-displayed + overflowed icons)`,
      },
      size: {
        type: `string`,
        enum: Object.values(IconSizeType),
        default: IconSizeType.Medium,
      },
      'track-properties': {
        default: {},
        type: `json`,
        tsType: `UserListTrackProperties`,
      },
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      defaultState: {},
      helpers: {
        handleOverflowTooltipShowed: () => {
          const trackProperties = this.attr(`track-properties`);
          if (trackProperties) {
            track(TrackingEvent.OverflowMenuShowed, trackProperties);
          }
        },
      },
    };
  }
}

export const UserListEl = defineAndMakeJsxFactory<JsxProps>(`mp-user-list`, UserList);
export const UserListReact = panel2react<JsxProps>(`mp-user-list`, UserList);
